export default __webpack_public_path__ + "static/media/therawee-logo-dark-compressed.9bbe7d1f.png";